module.exports = __webpack_public_path__ + "static/media/tag_logo.9445b0a2.svg";